import { NumberParamsCache } from './numbers';
/**
 * Private API only visible internally.
 *
 * @internal
 */
var PrivateApiImpl = /** @class */ (function () {
    function PrivateApiImpl(bundle, internals) {
        this.bundle = bundle;
        this.internals = internals;
        this.numberParamsCache = new NumberParamsCache(bundle, internals);
        this.contextTransforms = this.internals.schema.ContextTransforms.contextTransforms.mapping(this.bundle);
    }
    PrivateApiImpl.prototype.getNumberParams = function (numberSystem, defaultSystem) {
        return this.numberParamsCache.getNumberParams(numberSystem, defaultSystem);
    };
    PrivateApiImpl.prototype.getContextTransformInfo = function () {
        return this.contextTransforms;
    };
    return PrivateApiImpl;
}());
export { PrivateApiImpl };
